import { parseResponseContent, type ParsedContent } from '../parse-response-content';

export const parseContentSafely = (content: string): ParsedContent[] => {
  if (!content) {
    return [];
  }

  try {
    return parseResponseContent(content);
  } catch {
    return [{ type: 'text', content }];
  }
};
